import React from "react"
import styled from "styled-components"
import { Dropdown, FormInput, Label } from "buoy-core"
import { responsive } from "buoy-theme"

const diagnosesOptions = [
  {
    value: "3047",
    text: "Common Cold (Triage 1)",
  },
  {
    value: "39138",
    text: "Viral gastroenteritis (Triage 1)",
  },
  {
    value: "37354",
    text: "Insect Bite (Triage 1)",
  },
  {
    value: "2764",
    text: "Eczema (Triage 3)",
  },
  {
    value: "4199",
    text: "Influenza (Triage 3)",
  },
  {
    value: "4962",
    text: "Piriformis syndrome (Triage 4)",
  },
  {
    value: "37353",
    text: "Chlamydia (male 25-29) (Triage 5)",
  },
  {
    value: "14204",
    text: "Peptic ulcer (Triage 5)",
  },
  {
    value: "38946",
    text: "Preeclampsia (Triage 6)",
  },
  {
    value: "38087",
    text: "Atrial fibrillation (Triage 7 - Emergency)",
  },
]

const adzerkOptions = [
  {
    value: "true",
    text: "Adzerk",
  },
  {
    value: "false",
    text: "Legacy",
  },
]

const brands = [
  "Buoy",
  "froedtert",
  "uhhospitals",
  "inflammatorybackpain",
  "cirrusmd",
  "minuteclinic",
]

const SelectorContainer = styled.div`
  display: grid;
  ${responsive(
    "grid-template-columns",
    "repeat(2, 1fr)",
    "repeat(2, 1fr)",
    "repeat(2, 1fr)",
    "repeat(2, 1fr)",
    "repeat(1, 1fr)"
  )};
  grid-gap: 0px 10px;
  ${responsive("margin-bottom", "0", "0", "24px", "24px", "24px")};
`

const SelectorFormInput = styled(FormInput)`
  height: 44.8px;
  margin: 0;
`

const FullRowGridItem = styled.div`
  ${responsive("grid-column", "1 / 3", "1 / 3", "1 / 3", "1 / 3", "1")};
`

const GridItem = styled.div`
  width: 100%;
`

const CompletionSelectors = ({
  selectedDiagnosis,
  selectedBrand,
  adzerk,
  postal,
  time,
  onChangeInput,
  onChangeDropdown,
}) => {
  const brandOptions = brands.map(brand => {
    return { value: brand, text: brand }
  })

  return (
    <SelectorContainer>
      <FullRowGridItem>
        <Label>Diagnosis</Label>
        <Dropdown
          placeholder="Select"
          value={selectedDiagnosis}
          options={diagnosesOptions}
          onChange={onChangeDropdown("diagnosis")}
        />
      </FullRowGridItem>
      <GridItem>
        <Label>Backend</Label>
        <Dropdown
          placeholder="Select"
          value={adzerk}
          options={adzerkOptions}
          onChange={onChangeDropdown("adzerk")}
        />
      </GridItem>
      <GridItem>
        <Label>Brand</Label>
        <Dropdown
          placeholder="Select"
          value={selectedBrand}
          options={brandOptions}
          onChange={onChangeDropdown("brand")}
        />
      </GridItem>
      <GridItem>
        <Label>Postal code</Label>
        <SelectorFormInput
          placeholder="10004"
          value={postal}
          onChange={onChangeInput("postal")}
        />
      </GridItem>
      <GridItem>
        <Label>Time (UTC)</Label>
        <SelectorFormInput
          placeholder="HH:MM (24hr)"
          value={time}
          onChange={onChangeInput("time")}
        />
      </GridItem>
    </SelectorContainer>
  )
}

export default CompletionSelectors



// WEBPACK FOOTER //
// ./assets/dev/components/CompletionSelectors.js